const blue = "#1F45CF";

const darkBlue = Object.freeze({
  base: "#0B1031",
});

const lightBlue = Object.freeze({
  base: "#0B8AFF",
  lighten1: "#3CA1FF",
  lighten2: "#6CB9FF",
  lighten3: "#CEE8FF",
});

const yellow = Object.freeze({
  base: "#FEC92E",
  lighten1: "#FED458",
  lighten2: "#FEDF82",
  lighten3: "#FFF4D5",
});

const green = Object.freeze({
  base: "#31C17C",
  lighten1: "#5ACD96",
  lighten2: "#83DAB0",
  lighten3: "#D6F3E5",
});

const red = Object.freeze({
  base: "#F3365F",
  lighten1: "#F55E7F",
  lighten2: "#F8869F",
  lighten3: "#FDD7DF",
});

const orange = Object.freeze({
  base: "#FD8524",
  lighten1: "#FD9D50",
  lighten2: "#FEB67C",
  lighten3: "#FFE7D3",
});

const purple = Object.freeze({
  base: "#7B68EE",
  lighten2: "#CD36F3"
});

const pink = Object.freeze({
  base: "#FF69B4",
  lighten1: "#d90f7f"
})

const white = Object.freeze({
  base: "#fff",
});

const black = Object.freeze({
  base: "#000",
  lighten1: "#333"
});

const gray = Object.freeze({
  base: "#464F59",
  lighten1: "#747F8B",
  lighten2: "#8E99A7",
  lighten3: "#C9D0DA",
  lighten4: "#E5EAF0",
  lighten5: "#F6F7FB",
});

const golden = Object.freeze({
  base: "#DAA520",
});

export default Object.freeze({
  blue,
  darkBlue,
  lightBlue,
  yellow,
  green,
  red,
  orange,
  white,
  black,
  gray,
  purple,
  pink,
  golden,
});
